import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from 'moment';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-forum-giveaway-detail',
  templateUrl: './forum-giveaway-detail.component.html',
  styleUrls: ['./forum-giveaway-detail.component.css'],
})
export class AdminForumGiveawayDetailComponent implements OnInit {
  // countries$: Subject<Country[]> =new Subject();
  categories: Array<any>;
  category: any = {};
  filter = new FormControl('');

  giveaway: any = {
    status: true,
    image: '',
    endDate: '',
    images: [],
    description: '',
  };
  imgUrl = environment.ImageUrl;
  survey: any = {
    data: {
      status: 0,
      giveawaySurveyQuestions: [],
    },
    question: '',
    answer: [],
    openForm: false,
  };
  activeIndex: number | null = 0; // Initialize with the first accordion open
  giveawayId: any;

  private modalRef: any;

  /**
   * Constructor
   */
  constructor(
    // private modalService: NgbModal,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) {
    // this.countries$ = this.filter.valueChanges.pipe(
    // 	startWith(''),
    // 	map((text) => search(text)),
    // );
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      //queryParams
      if (params.get('id')) {
        this.giveawayId = params.get('id');
        this.initGiveaway(params.get('id'));
      }
    });
  }

  openForm(modal: any, item: any = this.giveaway) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'poll_form_modal',
    });
    this.giveaway = item;
  }

  deleteGiveaway(id: any) {
    this.local
      .alertConfirm({
        message: 'Are you sure want to delete this Survey ?',
      })
      .then((resp) => {
        this.auth.giveaway_survey_delete(id).subscribe((response: any) => {
          this.toastr.success('Survey Has Been Deleted');
          this.initSurvey(id);
          // this.initGiveaway()
        });
      });
  }

  publishSurvey() {
    this.local
      .alertConfirm({
        message: 'Are you sure want to publish this Survey ?',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.auth
            .giveaway_survey_publish({ id: this.survey.data.id })
            .subscribe((response: any) => {
              this.toastr.success('Survey Has Been Published');
              this.initSurvey(this.survey.data.id);
            });
        }
      });
  }

  initGiveaway(id) {
    this.giveaway.isLoading = true;
    this.auth.giveaway_find(id).subscribe((response: any) => {
      this.giveaway = response.body;
      this.giveaway.images = JSON.parse(this.giveaway.images);
      this.giveaway.endDate = moment(this.giveaway.endDate).format(
        'YYYY-MM-DD',
      );
      // this.giveaways.data.map((row: any) => {
      // })
    });
    this.initSurvey(id);
  }

  initSurvey(giveawayId) {
    this.auth.giveaway_survey_fetch(giveawayId, true).subscribe((resp: any) => {
      if (resp.body != null) {
        this.survey.data = resp.body;
        this.survey.data?.giveawaySurveyQuestions.map((row: any) => {
          row.answer = JSON.parse(row.answer);
        });
      }
    });
  }

  toggleAccordion(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

  putAnswer(value: string, index: number) {
    this.survey.answer[index] = value;
  }

  storeSurvey() {
    if (this.survey.question == '' || this.survey.answer.length < 1)
      return this.toastr.error('Please fill the inputs.');

    const formData = {
      giveawayId: this.giveawayId,
      question: this.survey.question,
      answer: this.survey.answer,
    };

    this.auth.giveaway_survey_store(formData).subscribe(
      (response: any) => {
        // this.initGiveaway()
        this.modalService.dismissAll();
        this.survey.openForm = false;
        this.initSurvey(this.giveaway.id);
        this.toastr.success('successfully added giveaway');
      },
      (e) => {
        this.toastr.error('failed to add giveaway');
      },
    );
  }

  handleAddImage() {
    this.giveaway.images = [
      ...this.giveaway.images,
      {
        filePreview:
          this.imgUrl + 'public/images/giveaway/1717001917886435375.png',
      },
    ];
  }

  removeAnswer(i: number) {
    this.survey.answer = this.survey.answer.filter(
      (row: any, index: number) => index != i,
    );
  }

  onImageChange(event: any, data: any) {
    if (event.target.files?.length === 0) {
      return;
    }

    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      data.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (event: any) => {
        data.filePreview = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }
}
